import { motion } from 'framer-motion';
import { Check, FileText } from 'lucide-react';

import { Card } from '@/components/ui/card';

import { DocumentCardProps } from '../types';

export function PipelineDocumentCard({
    document,
    progress,
}: DocumentCardProps) {
    const isLoading = progress?.splitting === 'loading';
    const isComplete = progress?.splitting === 'complete';

    return (
        <Card className="p-4 min-h-[80px]">
            {isLoading ? (
                <div className="space-y-3">
                    <div className="h-4 bg-muted rounded animate-pulse" />
                    <div className="h-3 bg-muted rounded w-2/3 animate-pulse" />
                </div>
            ) : isComplete ? (
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded bg-primary/10 flex items-center justify-center flex-shrink-0">
                        <FileText className="w-5 h-5 text-primary" />
                    </div>
                    <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2 mb-1">
                            <span className="text-xs font-semibold px-2 py-0.5 bg-muted rounded">
                                Doc {document.id}
                            </span>
                            <span className="text-xs font-semibold px-2 py-0.5 bg-blue-100 text-blue-700 rounded">
                                {document.type}
                            </span>
                            <motion.div
                                initial={{ scale: 0 }}
                                animate={{ scale: 1 }}
                                transition={{
                                    type: 'spring',
                                    stiffness: 500,
                                    damping: 30,
                                }}
                                className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0"
                            >
                                <Check className="w-3.5 h-3.5 text-green-600" />
                            </motion.div>
                        </div>
                        <div className="text-xs text-muted-foreground">
                            {document.pages} pages
                        </div>
                    </div>
                </div>
            ) : null}
        </Card>
    );
}
